import { core, toEnumString } from '@tock/coretypes';
import { noop } from 'es-toolkit/compat';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { AuthRequest, LoyaltyProgramConsumerTheme, LoyaltyProgramBalanceRequest } = protos;

export function login(email: string, password: string): ApiAction {
  return {
    TockApi: {
      postProto: '/integrations/paytronix/login',
      type: AppConstants.LOYALTY_PROGRAM_LOGIN,
      request: AuthRequest.fromObject({ email, password }),
    },
  };
}

export function fetchBalance(
  subtotalCents: number,
  discountsCents: number,
  numCovers: number,
  uniqueCheckNumber?: string,
  theme?: core.LoyaltyProgramConsumerTheme | null
): ApiAction<core.LoyaltyProgramBalance> {
  return toEnumString(LoyaltyProgramConsumerTheme, theme) === 'ANNEX_CLOUD_DEFAULT'
    ? fetchAnnexCloudBalance(subtotalCents, discountsCents)
    : fetchPaytronixBalance(subtotalCents, numCovers, uniqueCheckNumber);
}

export function fetchPaytronixBalance(
  subtotalCents: number,
  numCovers: number,
  uniqueCheckNumber?: string
): ApiAction<core.LoyaltyProgramBalance> {
  return {
    TockApi: {
      postProto: '/integrations/paytronix/balance',
      type: AppConstants.LOYALTY_PROGRAM_FETCH_BALANCE,
      context: subtotalCents,
      request: LoyaltyProgramBalanceRequest.fromObject({
        subtotalCents,
        numCovers,
        uniqueCheckNumber,
      }),
    },
  };
}

export function fetchAnnexCloudBalance(
  subtotalCents: number,
  discountsCents: number
): ApiAction<core.LoyaltyProgramBalance> {
  return {
    TockApi: {
      postProto: '/integrations/annexcloud/balance',
      type: AppConstants.LOYALTY_PROGRAM_FETCH_BALANCE,
      request: LoyaltyProgramBalanceRequest.fromObject({ subtotalCents, discountsCents }),
      ignoreNetworkErrors: true,
      onError: noop,
    },
  };
}

export function changeNumPoints(numPointsToRedeem: number): BaseTockAction {
  return {
    type: AppConstants.LOYALTY_PROGRAM_POINTS,
    payload: numPointsToRedeem,
  };
}

export function clear(): BaseTockAction {
  return {
    type: AppConstants.LOYALTY_PROGRAM_CLEAR,
  };
}

export function clearPaytronixLogin(): ApiAction {
  return {
    TockApi: {
      deleteProto: '/integrations/paytronix/login',
      type: AppConstants.LOYALTY_PROGRAM_CLEAR_LOGIN,
    },
  };
}
